import {combineReducers} from 'redux';
import app from './app';
import request from './request';
import application from './application';
import transaction from './transaction';

export default combineReducers({
  app,
  request,
  application,
  transaction,
});
